import { AppThunk, RootState } from "@/redux/store"
import { User } from "@/types/entities/user"
import { signOutClerk } from "@/core/auth/clerk"
import {
  clearLegacyAuthToken,
  setLegacyAuthToken,
} from "@/core/auth/legacyToken"
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type AuthState = {
  user?: User | null
}

const initialState: AuthState = {
  user: undefined,
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<User | null | undefined>) => {
      state.user = payload
    },
  },
})

export const selectUser = (state: RootState) => state.auth.user

export const { setUser } = authSlice.actions

export const loginUserAction =
  (user: User): AppThunk =>
  (dispatch) => {
    dispatch(setUser(user))
    setLegacyAuthToken(user.token)
  }

export const clearLocalAuthAction = (): AppThunk => (dispatch) => {
  dispatch(setUser(null))
  clearLegacyAuthToken()
}

export const logoutUserAction = (): AppThunk => (dispatch) => {
  dispatch(clearLocalAuthAction())
  void signOutClerk()
}

export default authSlice.reducer
